<div>
    <button [disabled]="disabled" mat-flat-button color="accent" (click)="signDocument()">
        <mat-icon>edit</mat-icon> {{ buttonText }}
    </button>
</div>
